export const SampleFilesUrl = {
  eligibilityTemplate: '/csvTemplates/eligibilityTemplate.csv',
  epicClaimTemplate: '/csvTemplates/epicClaimProcess.csv',
};
